export const LAST_PORTS_FIELDS = Object.freeze({
  PORT: "port",
  COUNTRY: "country",
  ARRIVAL_DATE: "arrivalDate",
  DEPARTURE_DATE: "departureDate",
  SECURITY_LEVEL: "securityLevel",
  COMMENTS: "comments",
});

export function formatDate(date: string | Date | undefined | null): string {
  if (!date) return "-";
  const d = typeof date === "string" ? new Date(date) : date;
  if (isNaN(d.getTime())) return "-";
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${dd}/${mm}/${yyyy}`;
}
